import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-emerald-deep text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <span className="text-emerald-deep font-display font-bold text-lg">U</span>
              </div>
              <span className="font-display text-xl font-semibold">Uprize Black Biz</span>
            </div>
            <p className="text-emerald-100/80 max-w-md">
              Celebrating and supporting Black-owned businesses across the United States. 
              Discover, connect, and grow with our vibrant community.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Explore</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/directory" className="text-emerald-100/80 hover:text-white transition-colors">
                  Business Directory
                </Link>
              </li>
              <li>
                <Link to="/directory?category=Restaurants" className="text-emerald-100/80 hover:text-white transition-colors">
                  Restaurants
                </Link>
              </li>
              <li>
                <Link to="/directory?category=Services" className="text-emerald-100/80 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/directory?category=Professional" className="text-emerald-100/80 hover:text-white transition-colors">
                  Professional
                </Link>
              </li>
            </ul>
          </div>

          {/* For Business Owners */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-emerald-100/80 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-emerald-100/80 hover:text-white transition-colors">
                  Register Your Business
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-emerald-100/80 hover:text-white transition-colors">
                  Sign In
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-emerald-100/80 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 pt-6 border-t border-emerald-800">
          <p className="text-emerald-100/70 text-xs text-center max-w-3xl mx-auto">
            <strong>Disclaimer:</strong> Uprize Black Biz is dedicated exclusively to supporting Black-owned businesses. 
            Business listings are reserved for Black-owned establishments only. All businesses must be legally registered 
            with their state and maintain active status. Food trucks and restaurants must have current, valid permits and 
            all required licenses. Businesses serving alcohol must maintain proper, up-to-date alcohol permits and licenses. 
            If a business is found to not be Black-owned, not legally registered, or lacking proper permits/licenses, 
            the listing will be deactivated and all purchases will be refunded. You may re-register once all legal 
            requirements are met. We prioritize customer satisfaction and safety above all.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="mt-6 pt-6 border-t border-emerald-800">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-emerald-100/60 text-sm">
              © {new Date().getFullYear()} Uprize Black Biz. All rights reserved.
            </p>
            <p className="text-emerald-100/60 text-sm flex items-center gap-1">
              Made with <Heart className="w-4 h-4 text-legacy-gold fill-legacy-gold" /> for the community
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
